import {ChunkData} from "../types";

export class ChunkDataDictionary implements ChunkData {
    private items: { [key: string]: string[] } = {};

    public containsKey(key: string): boolean {
        return this.items.hasOwnProperty(key);
    }

    public add(key: string, value: string): void {
        if (this.containsKey(key)) {
            this.items[key].push(value);
        } else {
            this.items[key] = [value];
        }
    }

    public remove(key: string): void {
        delete this.items[key];
    }

    public get(key: string): string[] {
        return this.items[key];
    }
}

export default new ChunkDataDictionary();
